// Global packages and components
import { Link } from '@remix-run/react'
import { Slider, BannerImage } from '~/components'

// Types
import type { CustomCategoryProps } from '~/types'

// Main export
const CustomCategories = ({ slides }: { slides: CustomCategoryProps[] }) => (
  <Slider
    className="-mx-2"
    arrowsInline={true}
    options={{
      arrows: true,
      pagination: false,
      breakpoints: {
        540: {
          perPage: 2,
          padding: { right: '5%' },
        },
        768: {
          perPage: 3,
          padding: { right: '5%' },
        },
        1280: {
          perPage: 4,
          padding: { right: '5%' },
        },
      },
      padding: { right: '25%' },
    }}
  >
    {slides.map((e, i) => (
      <div
        key={i}
        className="px-2"
      >
        <Link
          to={`/${e?.type}/c${e?.slug?.current}`}
          className="relative block aspect-tv rounded-xl"
        >
          <div className="relative z-[2] flex h-full flex-col justify-end p-3 text-white">
            <h4 className="mb-0 font-bold">{e.title}</h4>
          </div>
          {e?.image && <BannerImage image={e.image} />}
        </Link>
      </div>
    ))}
  </Slider>
)

export default CustomCategories
